/*
 * utils.common.ts
 *
 * Common utility functions.
 */
export class mcUtilsCommon {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public cpifCSVEscape(pxValue: any) {
    // Escape CSV's cell value
    // Verify value
    if (undefined === pxValue || null === pxValue) {
      pxValue = '';
    }
    if ('string' !== typeof pxValue) {
      pxValue = pxValue.toString();
    }
    // NOTE: excel does not display 'X' properly ==> 'x'
    pxValue = pxValue.replaceAll('X', 'x');
    // Escape double quote: " ==> ""
    pxValue = pxValue.split('"').join('""');
    // Enclose value with quote if comma (',') or \r or \n exists in value
    if (true === pxValue.includes(',') || true === pxValue.includes('\r') || true === pxValue.includes('\n')) {
      pxValue = '"' + pxValue + '"';
    }
    //
    return pxValue;
  }
}
//#end#
